import { Injector, Pipe, PipeTransform } from '@angular/core';
import { IFormRule, FormElementRegistry, ViewRuleRegistry, Farris, FrameContext, IButtonViewRule } from '@farris/devkit';
import { BehaviorSubject } from 'rxjs';
import { ToolbarPipe } from './toolbar_pipe';
@Pipe({ name: 'toolbarVisibility' })
export class ToolbarVisibilityPipe extends ToolbarPipe implements PipeTransform {
  private subjects: Map<string, BehaviorSubject<any>> = new Map<string, BehaviorSubject<any>>();
  constructor(protected injector: Injector, protected formElementRegistry: FormElementRegistry, private viewRuleRegistry: ViewRuleRegistry, protected frameContext: FrameContext) {
    super(injector, frameContext, formElementRegistry);
  }
  /**
   * è®¡ç®å·¥å·æ æé®æ¯å¦å¯è§ç¶æ
   * @param config - toolbarItemç¼å·åå¶å½åå¼
   * @param toolbarId - å·¥å·æ idï¼éåé¨æé®é¡¹id
   * @param version - version
   */
  transform(config: any, toolbarId: string, version: any) {
    if (!this.subjects.has(toolbarId)) {
      this.subjects.set(toolbarId, new BehaviorSubject<any>(null));
    }
    const subject = this.subjects.get(toolbarId);
    this.process(config, Farris.FormRule.RuleType.Visible);
    if (!this.formElementRegistry || !this.viewRuleRegistry) {
      subject.next(config);
      return subject;
    }
    Object.keys(config).forEach((toolbarItemId: string) => {
      const toolbarItem = this.formElementRegistry.getElementById(toolbarItemId);
      if (toolbarItem) {
        const viewRule = this.viewRuleRegistry.getRuleById(toolbarItemId) as IButtonViewRule;
        if (viewRule) {
          const ruleVisible = viewRule.visibility;
          const elementRule = toolbarItem.rules.find((item: IFormRule) => item.type === Farris.FormRule.RuleType.Visible);
          // è§åè®¾ç½®ä¸ºå¯è§
          if (ruleVisible) {
            if (!elementRule.dynamic) {
              config[toolbarItemId] = true;
            }
          } else {
            config[toolbarItemId] = false;
          }
        }
      }
    });
    subject.next(config);
    return subject;
  }
}
